export default {
  SERVICE_FEE: 'SERVICE_FEE',
  ALLOW_GIFT_PURCHASES: 'ALLOW_GIFT_PURCHASES',
  ITEM_DATES: 'ITEM_DATES',
}
